export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8">有任何问题或建议？欢迎通过以下方式与我们取得联系</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-200 transition-all">
            <span className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-xl mx-auto mb-3">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
            <span className="text-xs text-foreground-500">cooperation@51video.com</span>
          </div>

          <div className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-200 transition-all">
            <span className="w-10 h-10 flex items-center justify-center bg-accent-50 rounded-xl mx-auto mb-3">
              <i className="ri-customer-service-line text-xl text-accent-600"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">用户反馈</h3>
            <span className="text-xs text-foreground-500">feedback@51video.com</span>
          </div>

          <div className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-200 transition-all">
            <span className="w-10 h-10 flex items-center justify-center bg-secondary-50 rounded-xl mx-auto mb-3">
              <i className="ri-send-plane-line text-xl text-secondary-600"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
            <span className="text-xs text-foreground-500">submit@51video.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}